import {
  LIST_PRICE_CATEGORY_REQUEST,
  LIST_PRICE_CATEGORY_SUCCESS,
  LIST_PRICE_CATEGORY_FAIL,
  CREATE_PRICE_CATEGORY_REQUEST,
  CREATE_PRICE_CATEGORY_SUCCESS,
  CREATE_PRICE_CATEGORY_FAIL,
  DETAIL_PRICE_CATEGORY_REQUEST,
  DETAIL_PRICE_CATEGORY_SUCCESS,
  DETAIL_PRICE_CATEGORY_FAIL,
  UPDATE_PRICE_CATEGORY_REQUEST,
  UPDATE_PRICE_CATEGORY_SUCCESS,
  UPDATE_PRICE_CATEGORY_FAIL,
  DELETE_PRICE_CATEGORY_REQUEST,
  DELETE_PRICE_CATEGORY_SUCCESS,
  DELETE_PRICE_CATEGORY_FAIL,
  RESET_PRICE_CATEGORY
} from '../../constants/price-category'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingDetail: false,
  priceCategories: [],
  priceCategory: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listPriceCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_PRICE_CATEGORY_REQUEST:
      return { ...state, loading: true }
    case LIST_PRICE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        priceCategories: action.payload,
        pageable: action.pageable
      }
    case LIST_PRICE_CATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_PRICE_CATEGORY_REQUEST:
      return { ...state, loadingCreate: true, error: '' }
    case CREATE_PRICE_CATEGORY_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_PRICE_CATEGORY_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_PRICE_CATEGORY_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_PRICE_CATEGORY_SUCCESS:
      return { ...state, loadingDetail: false, priceCategory: action.payload }
    case DETAIL_PRICE_CATEGORY_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_PRICE_CATEGORY_REQUEST:
      return { ...state, loadingUpdate: true, error: '' }
    case UPDATE_PRICE_CATEGORY_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_PRICE_CATEGORY_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_PRICE_CATEGORY_REQUEST:
      return { ...state, loadingDelete: true, error: '' }
    case DELETE_PRICE_CATEGORY_SUCCESS:
      return { ...state, loadingDelete: false, error: '' }
    case DELETE_PRICE_CATEGORY_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_PRICE_CATEGORY:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default listPriceCategoryReducer
